import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRightIcon } from "@/components/icons/icons";
import { Link } from "gatsby";

const FeatureCard = ({ Icon, title, description, bgCustom, link, external = false }) => {
  const cardContent = (
    <div className={`rounded-lg ${bgCustom} p-6 shadow-lg h-full`}>
      <div className="flex items-center justify-between">
        <Icon className="h-8 w-8 text-white" />
        <Button className="text-white hover:text-blue-500" size="icon" variant="ghost" asChild>
          
            <ArrowRightIcon className="h-5 w-5" />
        </Button>
      </div>
      <h3 className="mt-4 text-lg font-bold text-white">{title}</h3>
      <p className="mt-2 text-gray-100">{description}</p>
    </div>
  );

  if (external) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {cardContent}
      </a>
    );
  }

  return (
    <Link to={link}>
      {cardContent}
    </Link>
  );
};

export default FeatureCard;
